import { Divider, useTheme } from "@mui/material";

const RowDivider = ({ ...props }) => {
  const theme = useTheme();
  const { sx, ...rest } = props;
  return (
    <Divider
      sx={{
        marginY: "12px",
        border: `.5px solid ${theme.palette.surface.light}08`,
        width: "100%",
        ...sx,
      }}
      {...rest}
    />
  );
};

export default RowDivider;
